import React from 'react';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    icon: {
        width: 100,
        height: 100,
    },
}));

export interface EmptyStateProps {
    icon?: React.ReactElement;
    iconRenderer?: () => React.ReactNode;
    children?: React.ReactNode;
}

export const EmptyState: React.FunctionComponent<EmptyStateProps> = props => {
    const IconComponent = props.icon;
    const classes = useStyles({});

    return (
        <div>
            {IconComponent && !props.iconRenderer && (
                <Box textAlign="center">
                    <IconComponent fontSize="large" color="disabled" className={classes.icon}/>
                </Box>
            )}
            {props.iconRenderer && props.iconRenderer()}
            {props.children}
        </div>
    );
};
